import { createFileRoute } from '@tanstack/react-router';

import { useAppMode } from 'component/root/AppModeProvider';
import SetPassword from 'component/view/Auth/SetPassword';

interface SetPasswordSearch {
  token?: string;
  email?: string;
  user_id?: string;
}

export const Route = createFileRoute('/set-password')({
  validateSearch: (search: Record<string, unknown>): SetPasswordSearch => ({
    token: typeof search.token === 'string' ? search.token : undefined,
    email: typeof search.email === 'string' ? search.email : undefined,
    user_id: search.user_id != null ? String(search.user_id) : undefined,
  }),
  component: SetPasswordRoute,
});

function SetPasswordRoute() {
  const { isWpSiteControl } = useAppMode();

  return <SetPassword isWpSiteControl={isWpSiteControl} />;
}
